import React, {useCallback, useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import DatePicker, {registerLocale} from "react-datepicker";
import {
    setTimeFrom,
    setTimeTo,
    setTimeframe,
    setFilterorderPriceFrom,
    setFilterorderPriceTo,
    setPriceFromInit,
    setPriceToInit,
} from "../../store/actions/settingsActions";
import Select from 'react-select';
import ru from "date-fns/locale/ru";
import en from "date-fns/locale/ru";
import el from "date-fns/locale/el";
import {
    setCustomFields, getFields, saveFields, setSort, setSort2, setSort3, setGroup
} from "../../store/actions/settingsActions";
import {ordersStructure, translateOptions, formatDbDate} from "../../config";
import Filters from "./settings/filter.jsx";
import {timeFrom, timeTo} from "../../utils/timeInterval";

if (window.locale === 'ru') {
    registerLocale("ru", ru);
} else if (window.locale === 'en') {
    registerLocale("en", en);
} else {
    registerLocale("el", el);
}


function Settings(props) {

    // Импорт диспатчера
    const dispatch = useDispatch();

    // Подписка на изменение стейта ордеров и настроек
    const orders = useSelector(state => state.orders);
    const settings = useSelector(state => state.settings);

    // Получение списка отмеченных юзером полей
    useEffect(() => {
        dispatch(getFields());
    }, []);

    let prices = orders.items.map(order => {
        return +order.orderPrice;
    }).sort();

    // Установка даты начала фильтрации ордеров
    const setTimeHandlerFrom = (date) => {
        dispatch(setTimeFrom(new Date(formatDbDate(date))));
    };

    // Установка даты конца фильтрации ордеров
    const setTimeHandlerTo = (date) => {
        dispatch(setTimeTo(new Date(formatDbDate(date))));
    };

    // Переменная для состояния визуального фильтра ордеров
    const [activeTabs, updateActiveTabs] = useState('');

    function HandlerToggleTabs(value) {
        if (value === activeTabs) {
            updateActiveTabs('');
        } else {
            updateActiveTabs(value);
        }
    }

    // Переменные для состояния сортировки
    const [sortKey, updateSortKey] = useState(settings.sort.key);
    const [sortDirection, updateSortDirection] = useState(settings.sort.direction);

    const [sort2Key, updateSort2Key] = useState(settings.sort2.key);
    const [sort2Direction, updateSort2Direction] = useState(settings.sort2.direction);

    const [sort3Key, updateSort3Key] = useState(settings.sort3.key);
    const [sort3Direction, updateSort3Direction] = useState(settings.sort3.direction);

    // Переменные для состояния группировки
    const [groupKey, updateGroupKey] = useState(settings.group.key);

    // Переменные для состояния фильтров цены
    let priceFrom = settings.filterorderPriceFrom === '' ? prices[0] : settings.filterorderPriceFrom
    let priceTo = settings.filterorderPriceTo === '' ? prices[prices.length - 1] : settings.filterorderPriceTo


    function HandlerSort() {

        let sortArray = [{
            sortKey: sortKey,
            sortDirection: sortDirection && sortKey ? sortDirection : (sortKey ? 'asc' : false)
        }, {
            sortKey: sort2Key, sortDirection: sort2Direction && sort2Key ? sort2Direction : (sort2Key ? 'asc' : false)
        }, {
            sortKey: sort3Key, sortDirection: sort3Direction && sort3Key ? sort3Direction : (sort3Key ? 'asc' : false)
        },];

        sortArray = sortArray.filter(item => {
            return item.sortKey;
        });

        if (sortArray[0]) {
            dispatch(setSort({key: sortArray[0].sortKey, direction: sortArray[0].sortDirection}));
            updateSortKey(sortArray[0].sortKey);
            updateSortDirection(sortArray[0].sortDirection);
        } else {
            dispatch(setSort({key: false, direction: false}));
            updateSortKey(false);
            updateSortDirection(false);
        }

        if (sortArray[1]) {
            dispatch(setSort2({key: sortArray[1].sortKey, direction: sortArray[1].sortDirection}));
            updateSort2Key(sortArray[1].sortKey);
            updateSort2Direction(sortArray[1].sortDirection);
        } else {
            dispatch(setSort2({key: false, direction: false}));
            updateSort2Key(false);
            updateSort2Direction(false);
        }

        if (sortArray[2]) {
            dispatch(setSort3({key: sortArray[2].sortKey, direction: sortArray[2].sortDirection}));
            updateSort3Key(sortArray[2].sortKey);
            updateSort3Direction(sortArray[2].sortDirection);
        } else {
            dispatch(setSort3({key: false, direction: false}));
            updateSort3Key(false);
            updateSort3Direction(false);
        }
    }

    function HandlerGroup() {
        if (groupKey) {
            dispatch(setGroup({key: groupKey}));
        } else {
            dispatch(setGroup({key: false}));
        }
    }

    function CreateFilterTab() {
        let tabClass = 'orders-settings__tab';

        if (activeTabs === 'filter') {
            tabClass = 'orders-settings__tab orders-settings__tab--active';
        }

        return <div className={tabClass}>
            <Filters/>
        </div>;
    }

    function CreateGroupTab() {
        let tabClass = 'orders-settings__tab';

        if (activeTabs === 'group') {
            tabClass = 'orders-settings__tab orders-settings__tab--active';
        }

        let groupOptions = [];

        for (let key in ordersStructure) {
            if (ordersStructure[key].isNeedSort) {
                groupOptions.push({value: key, label: `${ordersStructure[key].name} (${ordersStructure[key].desc})`});
            }
        }

        groupOptions.unshift({value: '', label: translateOptions.selectDefault});


        return <div className={tabClass}>

            <div className={'orders-settings__tab-group'}>
                <div className={'orders-settings__tab-group-select'}>
                    <Select
                        options={groupOptions}
                        classNamePrefix={'react-select'}
                        value={{
                            value: groupKey,
                            label: ordersStructure[groupKey] && ordersStructure[groupKey].name ? `${ordersStructure[groupKey].name} (${ordersStructure[groupKey].desc})` : ''
                        }}
                        onChange={event => {
                            if (event.value !== '') {
                                updateGroupKey(event.value);
                            } else {
                                updateGroupKey(false);
                            }
                        }}
                    />
                </div>
                <div className={'orders-settings__tab-group-button-wrapper'}>
                    <div className={'orders-settings__tab-group-button button button--input-row'}
                         onClick={HandlerGroup}>{translateOptions.groupButton}</div>
                </div>
            </div>
        </div>;
    }

    function CreateSortTab() {
        let tabClass = 'orders-settings__tab';

        if (activeTabs === 'sort') {
            tabClass = 'orders-settings__tab orders-settings__tab--active';
        }

        let sortOptions = [];
        let sortDirectionOptions = [{value: '', label: translateOptions.selectDefault}, {
            value: 'asc',
            label: translateOptions.asc
        }, {value: 'desc', label: translateOptions.desc},];

        for (let key in ordersStructure) {
            if (ordersStructure[key].isNeedSort) {
                sortOptions.push({value: key, label: `${ordersStructure[key].name} (${ordersStructure[key].desc})`});
            }
        }

        sortOptions.unshift({value: '', label: translateOptions.selectDefault});


        return <div className={tabClass}>

            <div className={'orders-settings__tab-sort'}>
                <div className={'orders-settings__tab-sort-select'}>
                    <Select
                        options={sortOptions}
                        classNamePrefix={'react-select'}
                        value={{
                            value: sortKey,
                            label: ordersStructure[sortKey] && ordersStructure[sortKey].name ? `${ordersStructure[sortKey].name} (${ordersStructure[sortKey].desc})` : ''
                        }}
                        onChange={event => {
                            if (event.value !== '') {
                                updateSortKey(event.value);
                            } else {
                                updateSortKey(false);
                            }
                        }}
                    />
                </div>
                <div className={'orders-settings__tab-sort-select'}>
                    <Select
                        options={sortDirectionOptions}
                        classNamePrefix={'react-select'}
                        value={{value: sortDirection, label: !sortDirection ? '' : translateOptions[sortDirection]}}
                        onChange={event => {
                            if (event.value !== '') {
                                updateSortDirection(event.value);
                            } else {
                                updateSortDirection(false);
                            }
                        }}
                    />
                </div>
            </div>

            <div className={'orders-settings__tab-sort'}>
                <div className={'orders-settings__tab-sort-select'}>
                    <Select
                        options={sortOptions}
                        classNamePrefix={'react-select'}
                        value={{
                            value: sort2Key,
                            label: ordersStructure[sort2Key] && ordersStructure[sort2Key].name ? `${ordersStructure[sort2Key].name} (${ordersStructure[sort2Key].desc})` : ''
                        }}
                        onChange={event => {
                            if (event.value !== '') {
                                updateSort2Key(event.value);
                            } else {
                                updateSort2Key(false);
                            }
                        }}
                    />
                </div>
                <div className={'orders-settings__tab-sort-select'}>
                    <Select
                        options={sortDirectionOptions}
                        classNamePrefix={'react-select'}
                        value={{value: sort2Direction, label: !sort2Direction ? '' : translateOptions[sort2Direction]}}
                        onChange={event => {
                            if (event.value !== '') {
                                updateSort2Direction(event.value);
                            } else {
                                updateSort2Direction(false);
                            }
                        }}
                    />
                </div>
            </div>

            <div className={'orders-settings__tab-sort'}>
                <div className={'orders-settings__tab-sort-select'}>
                    <Select
                        options={sortOptions}
                        classNamePrefix={'react-select'}
                        value={{
                            value: sort3Key,
                            label: ordersStructure[sort3Key] && ordersStructure[sort3Key].name ? `${ordersStructure[sort3Key].name} (${ordersStructure[sort3Key].desc})` : ''
                        }}
                        onChange={event => {
                            if (event.value !== '') {
                                updateSort3Key(event.value);
                            } else {
                                updateSort3Key(false);
                            }
                        }}
                    />
                </div>
                <div className={'orders-settings__tab-sort-select'}>
                    <Select
                        options={sortDirectionOptions}
                        classNamePrefix={'react-select'}
                        value={{value: sort3Direction, label: !sort3Direction ? '' : translateOptions[sort3Direction]}}
                        onChange={event => {
                            if (event.value !== '') {
                                updateSort3Direction(event.value);
                            } else {
                                updateSort3Direction(false);
                            }
                        }}
                    />
                </div>
            </div>

            <div className={'orders-settings__tab-sort-button-wrapper'}>
                <div className={'orders-settings__tab-sort-button button button--input-row'}
                     onClick={HandlerSort}>{translateOptions.sortButton}</div>
            </div>
        </div>;
    }

    function CreateFieldsTab() {
        let tabClass = 'orders-settings__tab';

        if (activeTabs === 'fields') {
            tabClass = 'orders-settings__tab orders-settings__tab--active';
        }

        let customFields = [];

        for (let key in settings.customFields) {
            customFields.push(key);
        }

        let iterKey = 0;

        function createCustomFieldCheckbox(key, iterKey) {
            let checkedState = false;

            if (settings.customFields[key]) {
                checkedState = true;
            }

            let checkName = ordersStructure[key].name;
            let checkDesc = ordersStructure[key].desc;

            const [state, setState] = useState(checkedState);

            return <div key={iterKey} className="orders-fields__item">
                <label className="checkbox">
                    <input className="checkbox__input" value={key} type="checkbox" checked={state} onChange={event => {
                        setState(!state);

                        let currentState = !state;
                        let key = event.target.value;

                        let customFields = {};

                        for (let customKey in settings.customFields) {
                            customFields[customKey] = settings.customFields[customKey];
                        }

                        customFields[key] = currentState;

                        dispatch(setCustomFields(customFields));

                    }}/>
                    <span className="checkbox__label">
                            {checkName}
                        <span className="checkbox__label-desc">{checkDesc}</span>
                        </span>
                </label>
            </div>;
        }

        let customFieldsCheckboxes = customFields.map(key => {
            iterKey++;
            return createCustomFieldCheckbox(key, `custom-fields-checkbox-${iterKey}`);
        });

        return <div className={tabClass}>
            <div className="orders-fields__items">
                {customFieldsCheckboxes}
                <div className="orders-fields__items-button button button--input-row" onClick={() => {
                    saveFields(settings.customFields);
                }}>{translateOptions.customFieldsSave}
                </div>
            </div>
        </div>;
    }

    let demoOrdersWrapperClass = '';

    if (window.demoChartPage) {
        demoOrdersWrapperClass = 'orders-settings--hide';
    }

    let loadingClass = !props.isLoad ? 'orders-settings--loading' : '';

    return <div className={`orders-settings ${demoOrdersWrapperClass} ${loadingClass}`}>
        <div className="orders-settings__items">
            <div className="orders-settings__item orders-settings__item--no-hover orders-settings__item--date">
                <div className="custom-datepicker">
                    <DatePicker
                        selected={settings.timeFrom}
                        onChange={(date) => setTimeHandlerFrom(date)}
                        className="custom-datepicker__input"
                        locale={window.locale}
                        dateFormat="dd.MM.yyyy"
                        minDate={timeFrom}
                        maxDate={timeTo}
                    />

                    <div className="custom-datepicker__separator"/>

                    <DatePicker
                        selected={settings.timeTo}
                        onChange={(date) => setTimeHandlerTo(date)}
                        className="custom-datepicker__input"
                        locale={window.locale}
                        dateFormat="dd.MM.yyyy"
                        minDate={timeFrom}
                        maxDate={timeTo}
                    />
                </div>
            </div>

            <div className="orders-settings__item orders-settings__item--no-hover orders-settings__item--prices">
                <div className="orders-settings__item-prices">
                    {ordersStructure.orderPrice.name} {priceFrom} - {priceTo}
                </div>
            </div>

            <div className="orders-settings__filters">
                <div className="orders-settings__item" onClick={() => {
                    HandlerToggleTabs('filter');
                }}>{translateOptions.tabsFilter}
                </div>
                <div className="orders-settings__item" onClick={() => {
                    HandlerToggleTabs('group');
                }}>{translateOptions.tabsGroup}
                </div>
                <div className="orders-settings__item" onClick={() => {
                    HandlerToggleTabs('sort');
                }}>{translateOptions.tabsSort}
                </div>
                <div className="orders-settings__item" onClick={() => {
                    HandlerToggleTabs('fields');
                }}>{translateOptions.tabsCustomFields}
                </div>
            </div>
        </div>

        <div className="orders-settings__tabs">
            <CreateFilterTab/>
            <CreateGroupTab/>
            <CreateSortTab/>
            <CreateFieldsTab/>
        </div>
    </div>;
}

export default Settings;
